import React from "react";
import Button from "@mui/material/Button";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {Link} from "react-router-dom";
import Rating from "@mui/material/Rating";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CardActions from "@mui/material/CardActions";
import Avatar from "@mui/material/Avatar";
import ViewHeadlineIcon from "@mui/icons-material/ViewHeadline";
import {useTheme} from "@mui/material/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import StackedBarChartIcon from "@mui/icons-material/StackedBarChart";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import {useTranslation} from "react-i18next";

export default function Examples() {
    const theme = useTheme();
    // init internationalization
    const {t} = useTranslation();

    return (
        <Grid
            id="examples-container"
            container
            spacing={4}
            sx={{padding: theme.spacing(4, 1)}}
        >
            <Grid item xs={12}>
                <Typography variant="h3" gutterBottom>
                    {" "}
                    {t("examples.PageTitle")}
                </Typography>
            </Grid>
            <div>
                <Grid item xs={5}>
                    <Link to="/examples" className="example-card">
                        <Card sx={{maxWidth: 800}} id="outlier-detection-example-action">
                            <CardMedia
                                component="img"
                                height="250"
                                image={t("examples.TeaserImageUrlExample1")}
                                alt=" Check out our example experiments."
                            />
                            <CardContent sx={{minHeight: 200}}>
                                <Typography variant="h4" gutterBottom>
                                    {t("examples.TitleExample1")}
                                </Typography>
                                <Typography component="legend">
                                    {t("examples.Difficulty")}
                                </Typography>
                                <Rating
                                    name="read-only"
                                    value={parseInt(t("examples.DifficultyRatingExample1"), 10)}
                                    readOnly
                                />
                                <Typography>{t("examples.DescriptionExample1")}</Typography>
                                <List
                                    sx={{
                                        width: "100%",
                                        paddingTop: theme.spacing(4),
                                        maxWidth: 500,
                                        bgcolor: "background.paper",
                                    }}
                                >
                                    <Typography variant="h7">
                                        {t("examples.DatasetInformation")}
                                    </Typography>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <ViewHeadlineIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={t("examples.NumDatapoints")}
                                            secondary={t("examples.NumDatapointsExample1")}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <ViewColumnIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={t("examples.NumFeatures")}
                                            secondary={t("examples.FeaturesExample1")}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <ScatterPlotIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={t("examples.TargetDescription")}
                                            secondary={t("examples.TargetsExample1")}
                                        />
                                    </ListItem>
                                </List>

                                <Typography variant="body1">
                                    {t("examples.Automatically")}
                                </Typography>

                                <List dense>
                                    <ListItem>
                                        <ListItemIcon>
                                            <FilterAltIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step1")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <ScatterPlotIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step2")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <QueryStatsIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step3")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <StackedBarChartIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step4")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <DownloadForOfflineIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step5")}</ListItemText>
                                    </ListItem>
                                </List>
                                <Typography>{t("examples.OutcomeExample1")}</Typography>
                            </CardContent>
                            <CardActions size="small">
                                <Button size="small">
                                    {t("examples.ButtonImportExample")}
                                    <KeyboardArrowRightIcon/>
                                </Button>
                            </CardActions>
                        </Card>
                    </Link>
                </Grid>
                <Grid item xs={5}>
                    <Link to="/examples" className="example-card">
                        <Card sx={{maxWidth: 800}} id="battery-testing-example-action">
                            <CardMedia
                                component="img"
                                height="250"
                                image={t("examples.TeaserImageUrlExample2")}
                                alt=" Check out our example experiments."
                            />
                            <CardContent sx={{minHeight: 200}}>
                                <Typography variant="h4" gutterBottom>
                                    {t("examples.TitleExample2")}
                                </Typography>
                                <Typography component="legend">
                                    {t("examples.Difficulty")}
                                </Typography>
                                <Rating
                                    name="read-only"
                                    value={parseInt(t("examples.DifficultyRatingExample2"), 10)}
                                    readOnly
                                />
                                <Typography>{t("examples.DescriptionExample2")}</Typography>
                                <List
                                    sx={{
                                        width: "100%",
                                        paddingTop: theme.spacing(4),
                                        maxWidth: 500,
                                        bgcolor: "background.paper",
                                    }}
                                >
                                    <Typography variant="h7">
                                        {t("examples.DatasetInformation")}
                                    </Typography>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <ViewHeadlineIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={t("examples.NumDatapoints")}
                                            secondary={t("examples.NumDatapointsExample2")}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <ViewColumnIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={t("examples.NumFeatures")}
                                            secondary={t("examples.FeaturesExample2")}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <ScatterPlotIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={t("examples.TargetDescription")}
                                            secondary={t("examples.TargetsExample2")}
                                        />
                                    </ListItem>
                                </List>

                                <Typography variant="body1">
                                    {t("examples.Automatically")}
                                </Typography>

                                <List dense>
                                    <ListItem>
                                        <ListItemIcon>
                                            <FilterAltIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step1")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <ScatterPlotIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step2")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <QueryStatsIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step3")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <StackedBarChartIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step4")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <DownloadForOfflineIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step5")}</ListItemText>
                                    </ListItem>
                                </List>
                                <Typography>{t("examples.OutcomeExample2")}</Typography>
                            </CardContent>
                            <CardActions size="small">
                                <Button size="small">
                                    {t("examples.ButtonImportExample")}
                                    <KeyboardArrowRightIcon/>
                                </Button>
                            </CardActions>
                        </Card>
                    </Link>
                </Grid>
            </div>
            <Grid container xs={10}>
                <Grid item xs={5}>
                    <Link to="/examples" className="example-card">
                        <Card sx={{maxWidth: 800}} id="outlier-detection-example-action">
                            <CardMedia
                                component="img"
                                height="250"
                                image={t("examples.TeaserImageUrlExample3")}
                                alt=" Check out our example experiments."
                            />
                            <CardContent sx={{minHeight: 200}}>
                                <Typography variant="h4" gutterBottom>
                                    {t("examples.TitleExample3")}
                                </Typography>
                                <Typography component="legend">
                                    {t("examples.Difficulty")}
                                </Typography>
                                <Rating
                                    name="read-only"
                                    value={parseInt(t("examples.DifficultyRatingExample3"), 10)}
                                    readOnly
                                />
                                <Typography>{t("examples.DescriptionExample3")}</Typography>
                                <List
                                    sx={{
                                        width: "100%",
                                        paddingTop: theme.spacing(4),
                                        maxWidth: 500,
                                        bgcolor: "background.paper",
                                    }}
                                >
                                    <Typography variant="h7">
                                        {t("examples.DatasetInformation")}
                                    </Typography>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <ViewHeadlineIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={t("examples.NumDatapoints")}
                                            secondary={t("examples.NumDatapointsExample3")}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <ViewColumnIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={t("examples.NumFeatures")}
                                            secondary={t("examples.FeaturesExample3")}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <ScatterPlotIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={t("examples.TargetDescription")}
                                            secondary={t("examples.TargetsExample3")}
                                        />
                                    </ListItem>
                                </List>

                                <Typography variant="body1">
                                    {t("examples.Automatically")}
                                </Typography>

                                <List dense>
                                    <ListItem>
                                        <ListItemIcon>
                                            <FilterAltIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step1")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <ScatterPlotIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step2")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <QueryStatsIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step3")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <StackedBarChartIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step4")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <DownloadForOfflineIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step5")}</ListItemText>
                                    </ListItem>
                                </List>
                                <Typography>{t("examples.OutcomeExample1")}</Typography>
                            </CardContent>
                            <CardActions size="small">
                                <Button size="small">
                                    {t("examples.ButtonImportExample")}
                                    <KeyboardArrowRightIcon/>
                                </Button>
                            </CardActions>
                        </Card>
                    </Link>
                </Grid>
                <Grid item xs={5}>
                    <Link to="/examples" className="example-card">
                        <Card sx={{maxWidth: 800}} id="outlier-detection-example-action">
                            <CardMedia
                                component="img"
                                height="250"
                                image={t("examples.TeaserImageUrlExample4")}
                                alt=" Check out our example experiments."
                            />
                            <CardContent sx={{minHeight: 200}}>
                                <Typography variant="h4" gutterBottom>
                                    {t("examples.TitleExample4")}
                                </Typography>
                                <Typography component="legend">
                                    {t("examples.Difficulty")}
                                </Typography>
                                <Rating
                                    name="read-only"
                                    value={parseInt(t("examples.DifficultyRatingExample4"), 10)}
                                    readOnly
                                />
                                <Typography>{t("examples.DescriptionExample4")}</Typography>
                                <List
                                    sx={{
                                        width: "100%",
                                        paddingTop: theme.spacing(4),
                                        maxWidth: 500,
                                        bgcolor: "background.paper",
                                    }}
                                >
                                    <Typography variant="h7">
                                        {t("examples.DatasetInformation")}
                                    </Typography>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <ViewHeadlineIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={t("examples.NumDatapoints")}
                                            secondary={t("examples.NumDatapointsExample4")}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <ViewColumnIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={t("examples.NumFeatures")}
                                            secondary={t("examples.FeaturesExample4")}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <ScatterPlotIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={t("examples.TargetDescription")}
                                            secondary={t("examples.TargetsExample4")}
                                        />
                                    </ListItem>
                                </List>

                                <Typography variant="body1">
                                    {t("examples.Automatically")}
                                </Typography>

                                <List dense>
                                    <ListItem>
                                        <ListItemIcon>
                                            <FilterAltIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step1")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <ScatterPlotIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step2")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <QueryStatsIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step3")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <StackedBarChartIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step4")}</ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <DownloadForOfflineIcon/>
                                        </ListItemIcon>
                                        <ListItemText>{t("examples.Step5")}</ListItemText>
                                    </ListItem>
                                </List>
                                <Typography>{t("examples.OutcomeExample1")}</Typography>
                            </CardContent>
                            <CardActions size="small">
                                <Button size="small">
                                    {t("examples.ButtonImportExample")}
                                    <KeyboardArrowRightIcon/>
                                </Button>
                            </CardActions>
                        </Card>
                    </Link>
                </Grid>
            </Grid>
        </Grid>
    );
}
